/**
 * The all-rentals SRP lives at the bare area URL (`/{area}`), not under a slug segment (HP-9411).
 *
 * hotpads-api names it `rentals` and canonicalizes it to `/{area}`. Until the slug catalog lists
 * `rentals`, `apartments-for-rent` is still the slug that imposes no type filter, so the bare page
 * and every "neutral" search anchor send that instead. The switch happens at runtime when the
 * catalog changes; see `resolveAllRentalsSlug` in `slugCatalog.ts`.
 */
export const ALL_RENTALS_SLUG = 'rentals';
export const INTERIM_ALL_RENTALS_SLUG = 'apartments-for-rent';

const AREA_SEGMENT = /^[a-z0-9]+(?:-[a-z0-9]+)*$/i;

/** A bare one-segment URL can be an area only if it has a resourceId's shape. */
export function hasAreaSegmentShape(segment: string): boolean {
  return AREA_SEGMENT.test(segment);
}

export function isAllRentalsSlug(slug: string | undefined): boolean {
  return slug === ALL_RENTALS_SLUG;
}

/** True while the bare page still borrows apartments-for-rent's search, and so its words. */
export function isInterimAllRentalsSlug(slug: string | undefined): boolean {
  return slug === INTERIM_ALL_RENTALS_SLUG;
}
